module.exports = __webpack_public_path__ + "img/backUp.f1e4cccd.jpg";